"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultFormConfig = void 0;
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
function useDefaultFormConfig(params) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return {
        type: 'form',
        children: [
            ...((params === null || params === void 0 ? void 0 : params.hideName)
                ? []
                : [
                    {
                        type: 'form.text',
                        key: 'name',
                        label: t('common.name'),
                        validate: {
                            required: true,
                        },
                    },
                ]),
            {
                type: 'form.select',
                key: 'status',
                label: t('common.status'),
                validate: {
                    required: true,
                },
                values: [
                    {
                        value: 'active',
                        label: t('classifiers.statusEnum.active'),
                    },
                    {
                        value: 'deprecated',
                        label: t('classifiers.statusEnum.deprecated'),
                    },
                    {
                        value: 'retired',
                        label: t('classifiers.statusEnum.retired'),
                    },
                ],
            },
            ...((params === null || params === void 0 ? void 0 : params.displayOrder)
                ? [
                    {
                        type: 'form.number',
                        key: 'displayOrder',
                        label: t('classifiers.displayOrder'),
                    },
                ]
                : []),
        ],
    };
}
exports.useDefaultFormConfig = useDefaultFormConfig;
